









































































































































































import { Component, Prop, Vue, Inject } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { CrudService } from '@/data/services/crud.service';
import { Conto, ContoGruppo, ContoType } from '@/data/models/conto.model';
import { cloneDeep } from 'lodash';

@Component({
	components: {
		ValidationObserver,
		ValidationProvider
	}
})
export default class EditConto extends Vue {
	@Prop() conto?: Conto;
	@Prop() type!: string;

	@Inject('CrudService') contoCrudService!: CrudService<Conto>;

	newConto!: Conto;

	typeItems: string[] = Object.keys(ContoType).map(
		// @ts-ignore
		(k: string) => ContoType[k]
	);
	gruppoItems: string[] = Object.keys(ContoGruppo).map(
		// @ts-ignore
		(k: string) => ContoGruppo[k]
	);

	constructor() {
		super();
		this.newConto = new Conto();
		this.newConto.tipogruppo = 0;

	}

	beforeMount() {
		if (this.conto && this.conto.id) {
			this.newConto = cloneDeep(this.conto);			
		}
	}

	submit() {
		this.$emit('submit', this.newConto);
	}

	get typeMastro(): boolean {
		return this.type === ContoType.MASTRO;
	}

	get typeConto(): boolean {
		return this.type === ContoType.CONTO;
	}

	get typeSottoconto(): boolean {
		return this.type === ContoType.SOTTOCONTO;
	}

}
